import { useEffect, useState } from "react";

const useTimerHook = (props) => {
  const [state, setState] = useState(props);

  useEffect(() => {
    setState(props);
  }, [props]);

  useEffect(() => {
    if (state <= 0) return;

    const timer = setTimeout(() => {
      setState(state - 1);
    }, 60000);

    return () => {
      clearTimeout(timer);
    };
  }, [state]);

  return state < 0 ? 0 : state;
};

export default useTimerHook;
